import { BookOpen, MessageCircle, Wine, Crown } from "lucide-react";
import Reveal from "@/components/Reveal";

const pillars = [
  { Icon: BookOpen, title: "Good Books", text: "Curated reads by Black women and authors whose stories inspire conversation, reflection, and discovery." },
  { Icon: MessageCircle, title: "Real Conversations", text: "Thoughtful discussions that create room for perspective, laughter, vulnerability, learning, and growth." },
  { Icon: Wine, title: "Beautiful Gatherings", text: "Brunches, dinners, wine nights, reading nights, and thoughtfully curated cultural experiences." },
  { Icon: Crown, title: "Sisterhood", text: "A welcoming community where Black women connect, support one another, and build genuine relationships." },
];

export const Pillars = () => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
    {pillars.map((p, i) => (
      <Reveal key={p.title} delay={i * 0.08}>
        <div className="h-full bg-mahogany-800/40 gold-frame rounded-sm p-8 transition-colors duration-500 hover:bg-mahogany-800/70" data-testid={`pillar-${p.title.toLowerCase().replace(/ /g, "-")}`}>
          <div className="w-14 h-14 rounded-full border border-gold/40 flex items-center justify-center mb-6">
            <p.Icon size={24} className="text-gold" strokeWidth={1.25} />
          </div>
          <h3 className="font-serif text-2xl text-cream mb-3">{p.title}</h3>
          <p className="text-cream/60 text-sm leading-relaxed">{p.text}</p>
        </div>
      </Reveal>
    ))}
  </div>
);

export default Pillars;
